import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

export function PageLayout({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        "flex w-full max-w-6xl flex-col gap-6 self-center p-4 sm:p-6 lg:p-10",
        className,
      )}
    >
      {children}
    </div>
  )
}

// IMP-518 (Compass): page titles sit at text-lg — the page's structure comes
// from spacing and ink contrast rather than display-size type.
export function PageHeading({ children }: { children: ReactNode }) {
  return <h1 className="text-lg/7 font-semibold">{children}</h1>
}

// One-line description under the heading; pairs with PageHeading inside a
// `flex flex-col gap-1` block.
export function PageDescription({ children }: { children: ReactNode }) {
  return <p className="text-muted-foreground text-sm">{children}</p>
}

// Use alongside PageHeading when the page has a sub-row of meta info / actions.
export function PageHeadingBar({
  children,
  heading,
}: {
  children: ReactNode
  heading: ReactNode
}) {
  return (
    <div>
      <PageHeading>{heading}</PageHeading>
      <div className="mt-2 flex flex-wrap items-center justify-between gap-x-6 gap-y-4">
        {children}
      </div>
    </div>
  )
}
